/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, CardHeader, Button } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useChangePassword } from "../../services/auth-api";
import Loader from "../../components/PageLoader";
import BreadCrumb from "../../components/breadCrumb";
import { Paths } from "../../routes/paths";
import FormInput from "../../components/forms/form-Input";
import ResetPasswordChecklist from "../../components/users/ResetPasswordChecklist";

export default function ChangePassword() {
  const navigate = useNavigate();
  const {
    mutate: changePassword,
    data: changePasswordRes,
    isPending: changingPassword,
  } = useChangePassword();

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { oldPassword: "", newPassword: "", verifyNewPassword: "" },
  });

  const [isChecklistValid, setIsChecklistValid] = useState(false);
  const generalFieldProps = { control, errors };
  const password = watch("newPassword");
  const confirmPassword = watch("verifyNewPassword");

  useEffect(() => {
    if (changePasswordRes) {
      navigate("/");
    }
  }, [changePasswordRes]);

  const verificationRules = {
    oldPassword: {
      required: "Please Enter Old Password",
    },
    newPassword: { required: "Please Enter New Password" },
    verifyNewPassword: { required: "Please Verify New Password" },
  };

  const submitInfo = (data) => {
    const payload = {
      oldPassword: data.oldPassword,
      newPassword: data.newPassword,
    };
    changePassword(payload);
  };

  return (
    <>
      {changingPassword ? <Loader /> : <> </>}
      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Profile", link: Paths.profile },
            { text: "Change Password", isCurrentPage: true },
          ]}
        />
        <div className="w-full h-full flex items-center justify-center mt-5">
          <Card className="w-[500px]">
            <CardHeader>Change Password</CardHeader>
            <CardBody>
              <form onSubmit={handleSubmit(submitInfo)}>
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  name="oldPassword"
                  label="Old Password"
                  formControlProps={{ width: "100%" }}
                  rules={verificationRules.oldPassword}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  name="newPassword"
                  label="New Password"
                  formControlProps={{ width: "100%" }}
                  rules={verificationRules.newPassword}
                />
                <FormInput
                  {...generalFieldProps}
                  isRequired
                  name="verifyNewPassword"
                  label="Verify New Password"
                  formControlProps={{ width: "100%" }}
                  rules={verificationRules.verifyNewPassword}
                />

                <ResetPasswordChecklist
                  password={password}
                  confirmPassword={confirmPassword}
                  onChange={setIsChecklistValid}
                />

                <div className="w-full flex justify-end mt-4">
                  <Button type="submit" isDisabled={!isChecklistValid}>
                    Update Password
                  </Button>
                </div>
              </form>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}
